import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';

export const showAnimation = trigger('showAnimation', [
  state('1', style({
    opacity: 1,
    visibility: 'visible',
    display: 'block',
  })),
  state('0', style({
    opacity: 0,
    visibility: 'hidden',
    display: 'none',
  })),
  transition('0 => 1', [animate('0.4s ease-in',
    keyframes([
      style({opacity: 0, display: 'block', offset: 0}),
      style({opacity: 1, display: 'block', offset: 1.0}),
    ]),
  )]),
  transition('1 => 0', [animate('0s ease-in',
    keyframes([
      style({opacity: 1, display: 'block', offset: 0}),
      style({opacity: 0, display: 'block', offset: 0.95}),
      style({opacity: 0, display: 'none', offset: 1.0}),
    ]),
  )]),
]);
